import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { compose } from "recompose";

import {
  selectLatestPhotos,
  selectMostPopularPhotos,
} from "../../../services/redux/photos/selectors";
import {
  getPhotos,
  voteOnPhoto,
  getPopularPhotos,
  unvoteOnPhoto,
} from "../../../services/redux/photos/reducer";
import { GET_PHOTOS_LATEST } from "../../../services/redux/photos/actions";
import Section from "../../blocks/Section/Section";
import ShowOffFieldGallery from "../ShowOffField/ShowOffFieldGallery";
import { PhotoModal } from "../ShowOffField/Components";

import AddPhotoButton from "../AddPhotoButton/AddPhotoButton";
import { PhotographicCompetition } from "../Sidebar/Widgets";

import "./Sections.scss";

const ShowOffSection = ({
  latest,
  mostPopular,
  getPhotos,
  getPopularPhotos,
  voteOnPhoto,
  unvoteOnPhoto,
  withWidget,
  withoutPopularWeek,
  t,
}) => {
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    getPhotos({
      params: {
        ordering: "-published_at",
        publish_status: "2",
        limit: 9,
      },
      type: GET_PHOTOS_LATEST,
    });
    getPopularPhotos({
      params: {
        ordering: "votes_count",
        limit: 9,
      },
    });
  }, []);
  return (
    <Section
      className="section_show-off"
      title={
        <h2 className="section_show-off--header">
          <div>
            {t("widgets:gallery.title")}{" "}
            <small>{t("widgets:gallery.subtitle")}</small>
          </div>
          <span>
            <AddPhotoButton />
          </span>
        </h2>
      }
      extra={withWidget && <PhotographicCompetition />}
    >
      <>
        {!withoutPopularWeek && (
          <>
            <div className="Sections__subtitle">
              {t("widgets:gallery.popularWeek")}
              <Link className="Sections__more" to="/galeria">
                {t("widgets:gallery.seeAll")}
              </Link>
            </div>
            <ShowOffFieldGallery
              chunks={4}
              md="3"
              photos={mostPopular.results}
              onClick={photo => setSelected(photo)}
              onVoteClick={({ slug, voted }) => {
                if (voted) {
                  unvoteOnPhoto({ slug });
                } else {
                  voteOnPhoto({ slug });
                }
              }}
            />
            <hr />
          </>
        )}
        <div className="Sections__subtitle">
          {t("widgets:gallery.lastAdded")}
          <Link className="Sections__more" to="/galeria?sort=-published_at">
            {t("widgets:gallery.readMoreLast")}
          </Link>
        </div>
        <ShowOffFieldGallery
          chunks={4}
          md="3"
          photos={latest.results}
          onClick={photo => setSelected(photo)}
          onVoteClick={({ slug, voted }) => {
            if (voted) {
              unvoteOnPhoto({ slug });
            } else {
              voteOnPhoto({ slug });
            }
          }}
        />
      </>
      <PhotoModal
        isOpen={selected !== null}
        onRequestClose={() => setSelected(null)}
        meta={selected}
        onRelatedClick={photo => setSelected(photo)}
        onVoteClick={({ slug, voted }) => {
          setSelected({
            ...selected,
            votes_count: voted
              ? selected.votes_count - 1
              : selected.votes_count + 1,
            voted: !voted,
          });
          if (voted) {
            unvoteOnPhoto({ slug });
          } else {
            voteOnPhoto({ slug });
          }
        }}
      />
    </Section>
  );
};

ShowOffSection.propTypes = {
  withWidget: PropTypes.bool,
};

ShowOffSection.defaultProps = {
  withWidget: false,
};

export default compose(
  withTranslation(["widgets"]),
  connect(
    state => ({
      latest: selectLatestPhotos(state),
      mostPopular: selectMostPopularPhotos(state),
    }),
    {
      getPhotos,
      voteOnPhoto,
      getPopularPhotos,
      unvoteOnPhoto,
    }
  )
)(ShowOffSection);
